import React from 'react';
import { Card, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

interface ParameterCardProps {
  loading: boolean;
  dataSource: any[];
  columns: ColumnsType<any>;
  accordionOpen?: boolean;
  onAccordionToggle?: () => void;
}

const ParameterCard: React.FC<ParameterCardProps> = ({ loading, dataSource, columns, accordionOpen, onAccordionToggle }) => (
  <Card
    title={
      typeof accordionOpen === 'boolean' && typeof onAccordionToggle === 'function' ? (
        <div
          role='button'
          tabIndex={0}
          onClick={onAccordionToggle}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onAccordionToggle?.();
            }
          }}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
        >
          <span>Kontrol Kapsamı</span>
          <span>{accordionOpen ? '-' : '+'}</span>
        </div>
      ) : (
        'Kontrol Kapsamı'
      )
    }
    className='br-30px mt-16px'
    loading={loading}
  >
    {typeof accordionOpen !== 'boolean' || accordionOpen ? (
      <Table className='parameter-table' dataSource={dataSource} columns={columns} pagination={false} rowKey='key' />
    ) : null}
  </Card>
);

export default ParameterCard;
